import React from 'react';
import {
  HashRouter as Router,
  Switch,
  Route,
  Redirect,
} from 'react-router-dom';

import Level from './views/level';
import Brand from './views/brand';
import Home from './views/home';

const routes = [
  {
    path: '/home/:seriesId',
    component: Home,
  },
  {
    path: '/level/:type',
    component: Level,
  },
  {
    path: '/brand/:ev',
    component: Brand,
  },
];

// A special wrapper for <Route> that knows how to
// handle "sub"-routes by passing them in a `routes`
// prop to the component it renders.
const RouteWithSubRoutes = (route) => {
  const {
    path,
    computedMatch,
  } = route;

  return (
    <Route
      path={path}
      render={(props) => (
        // pass the sub-routes down to keep nesting
        <route.component  {...props} params={computedMatch.params} routes={route.routes} />
      )}
    />
  );
};

// This example shows how to render two different screens
// (or the same screen in a different context) at the same URL,
// depending on how you got there.
//
// Click the "featured images" and see them full screen. Then
// "visit the gallery" and click on the colors. Note the URL and
// the component are the same as before but now we see them
// inside a modal on top of the gallery screen.
export default function App() {

  return (
    <>
      <Router>
        <Switch>
          {routes.map((route, i) => (
            <RouteWithSubRoutes key={i} {...route} />
          ))}
          <Route path="/">
            <Redirect to="/brand/all" />
          </Route>
        </Switch>
      </Router>
    </>
  );
}
